// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import FilterFilledSvg from "@ant-design/icons-svg/lib/asn/FilterFilled";
import AntdIcon from "../components/AntdIcon";
const FilterFilled = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: FilterFilledSvg
    });
if (process.env.NODE_ENV !== "production") {
    FilterFilled.displayName = "FilterFilled";
}
export default /*#__PURE__*/ React.forwardRef(FilterFilled);
